import "./CSS/main-view-app.scss";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Channel, Topic } from "../../constants";
import { MessageBrokerUtils } from "../../utils";
import { UISelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { useAppContainerReady } from "../../hooks/useAppContainerReady";

const MainViewApp = props => {
  const { onToggleMainViewApp } = props;

  const mainViewApp = useSelector(UISelectors.mainViewApp);
  const POKER_HISTORY_APPID = "POKER_HISTORY";

  useAppContainerReady(mainViewApp);

  useEffect(() => {
    const appCloseSub = MessageBrokerUtils.subscribe({
      channel: Channel.UI,
      topic: Topic.RemoveAppContainer,
      callback: data => {
        if (data?.appID === POKER_HISTORY_APPID) {
          onToggleMainViewApp(false);
        }
      }
    });
    return () => {
      appCloseSub?.unsubscribe();
    };
  }, [onToggleMainViewApp]);

  useEffect(() => {
    const onAppInitSucceeded = data => {
      if (data?.appID !== undefined && data.appID === mainViewApp?.appID) {
        toggleSpinner(false);
      }
    };

    const appInitSucceededSub = MessageBrokerUtils.subscribe({
      channel: Channel.SESSION,
      topic: Topic.appInitSucceeded,
      callback: onAppInitSucceeded
    });

    if (!!mainViewApp) {
      if (mainViewApp?.appID === POKER_HISTORY_APPID) {
        onToggleMainViewApp(true);
      }
      if (mainViewApp.error) {
        toggleSpinner(true, true);
      } else {
        toggleSpinner(true);
      }
      return () => {
        appInitSucceededSub?.unsubscribe();
        toggleSpinner(false, false, true);
      };
    }
  }, [mainViewApp, onToggleMainViewApp]);

  const toggleSpinner = async (visible, isError = false, clearError = false) =>
    MessageBrokerUtils.publish({
      channel: Channel.VIEW_INJECTOR,
      topic: Topic.SetVisible,
      headers: { publisher: "MainAppView" },
      data: { visible, isError, clearError }
    });

  return (
    (mainViewApp && mainViewApp?.containerID && (
      <div id={mainViewApp.containerID} className={"main-view-app"} />
    )) ||
    null
  );
};

MainViewApp.propTypes = {
  onToggleMainViewApp: PropTypes.func
};

export default MainViewApp;
